import styled from 'styled-components';

export const ArrowInteractive = styled.div`
  width: 100%;
  top: 64px;
  position: absolute;
  display: flex;
  justify-content: end;
`;
